/* eslint-disable no-dupe-keys */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Button,
    Block,
    Icon,
    Col,
    Row,
} from "../../../../components/Component";
import {
    Spinner
} from "reactstrap";
import Head from "../../../../layout/head/Head";
import OptionM from "../../../components/DynmicOption/OptionM";
import OptionC from "../../../components/DynmicOption/OptionC";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import TradeData from "./UpdateData/TradeData";
import TradeGrandTotal from "./Total/GrandTotal/TradeGrandTotal";
import TradeTotal from "./Total/TradeTotal";
import TradeTotalGT from "./Total/TradeTotalGT";
import CenterOption from "../../../components/DynmicOption/CenterOption";

const Trade = ({ ...props }) => {
    const [Statee, setStatee] = useState([]);
    const [others, setothers] = useState([]);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]

    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth(): sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 10,
        state: 0,
        generate: 0,
        CenterId: 0
    });
    const [generate1, setgenerate1] = useState(false);
    const [userData, setuserData] = useState([]);
    const [selectcenter, setselctcenter] = useState(false)
    const tableRef = useRef(null);
 
    const getdata = async () => {
        const sendData = {
            OrgId: Number(2),
            UserId: Number(formData.CenterId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardDataAdminDynamic', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*//console.log(data)*/
                 
                    setStatee(data)
                })


    };


    const usergetdata = async () => {


        const sendData = {
            EmploymentRefId: Number(10),
            MonthId: Number(-5),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    var maindata = data.filter(t => t.parentId === -5 && t.parametersId !== 265 && t.parametersId !== 266)
                    var maindata2 = data.filter(t => t.parentId === -5 && (t.parametersId === 265 || t.parametersId === 266))
                    setuserData(maindata)
                    setothers(maindata2)
                })


    };

    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange2 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const onInputChangeCenter = (e) => {
        // //console.log(e.target.value)
        setselctcenter(false)
        setFormData({ ...formData, CenterId: e.target.value });

    };

    useEffect(() => {
        usergetdata()
    }, [])


 


    const generate = async () => {
        getdata()
        setFormData({ ...formData, generate: formData.generate + 1 })
        setgenerate1(true)
        if (formData.CenterId === 0) {
            setselctcenter(true)
        }
        setTimeout(() => {
            setLorder(false)
        }, 10000);
    }



    return (
        <React.Fragment>
            <Head title="Trainees" />

            <Content>


                <Block>
                            <Row >

                                <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>DA Dashboard</h5>
                                    </td>
                                </Col>
                        <Col xl="3" md="3">
                            <label style={{ color: 'black', fontSize: 14 }}>  Center :  <label style={{ fontWeight: 'bold' }}><CenterOption defaultValuemain={formData.CenterId} catid="42" onInputChange={onInputChangeCenter} namemain="year" mainid="year" /></label></label>
                        </Col>
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 12 }}>  From :  <label style={{ fontWeight: 'bold' }}><OptionC defaultValuemain={formData.year} catid="42" onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                                </Col>
                                <Col xl="3" md="3" >
                                <label style={{ color: 'black', fontSize: 14 }}> To:  <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>


                        </Col>
                        <Col xl="3" md="3" >
                            <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button>


                        </Col>
                            </Row>
                    <hr />
                    {generate1 ? <>
                    <Row>
                        <Col md="2" lg="3">
                          
                        </Col>
                        <Col md="2" lg="3">
                           
                        </Col>
                        <Col md="2" lg="3">
                            
                        </Col>


                            {lorder ? <Col md="2" lg="3">

                                <Button style={{ float: "right", marginBottom: 10 }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>

                            </Col> : <Col md="2" lg="3">
                                <DownloadTableExcel
                                    filename="Trainees Report"
                                    sheet="users"
                                    currentTableRef={tableRef.current}
                                >
                                    <Button style={{ float: "right", marginBottom: 10 }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                </DownloadTableExcel>
                            </Col>}
                    </Row>
                    <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                        <table className="table table-orders" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 , border: '1px solid black' }}>
                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                        <tr>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                Form: Trade Report

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                From Date: {month1[formData.month]} {formData.year}

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                To Date: {month1[formData.tomonth]} {formData.toyear}

                                            </th>
                                        </tr>
                                    </thead>
                                </div>
                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                    <th  style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                       
                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                       
                                    </th>
                                    <th colSpan={Statee.length} style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                        Number of Trainees on Roll
                                    </th>
                                   {selectcenter === true ? <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                      Grand Total
                                    </th> :null}
                                   
                                </tr>
                               
                            
                                <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                        Sno
                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                        Trade List of NCSC-DAs
                                    </th>
                                    {Statee.length !== 0 ? Statee.map((details) =>
                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                            {details.state}

                                    </th> 
                                  
                                    ) : null}
                                    </tr>
                               
                            </thead>

                            <tbody>
                            
                                {userData.length !== 0 ? userData.map((data, index) =>
                             
                                    
                                            <tr>
                                                <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                                    {index + 1}

                                                </th>

                                                <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                                    {data.name}

                                                </th>
                                                {Statee.length !== 0 ? Statee.map((details) =>
                                                    <>
                                                        <TradeData Month={formData.month} tomonth={formData.tomonth} generate={formData.generate} toyear={formData.toyear} year={formData.year} UserId={details.userId} parametersId={data.parametersId} />
                                                    </>
                                        ) : <Spinner color="success" />}
                                        {selectcenter === true ? <TradeTotal Month={formData.month} tomonth={formData.tomonth} generate={formData.generate} toyear={formData.toyear} year={formData.year} parametersId={data.parametersId} /> : null}

                                            </tr>
                                   
                                ) : null}
                                {others.length !== 0 ? others.map((data, index) =>


                                    <tr>
                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                            {index + 1 + userData.length}

                                        </th>

                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                            {data.name}

                                        </th>
                                        {Statee.length !== 0 ? Statee.map((details) =>
                                            <>
                                                <TradeData Month={formData.month} tomonth={formData.tomonth} generate={formData.generate} toyear={formData.toyear} year={formData.year} UserId={details.userId} parametersId={data.parametersId} />
                                            </>
                                        ) : <Spinner color="success" />}
                                        {selectcenter === true ? <TradeTotal Month={formData.month} tomonth={formData.tomonth} generate={formData.generate} toyear={formData.toyear} year={formData.year} parametersId={data.parametersId} /> : null}

                                    </tr>

                                ) : null}
                              
                            </tbody>
                            <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', color: 'black' }}>
                                <th colSpan="2" style={{  textAlign: 'center', border: '1px solid black', backgroundColor: '#eaf8dd', padding: 10, fontWeight: "bold", minWidth: 100 }}>
                                    Total

                                </th>
                                {Statee.length !== 0 ? Statee.map((details) =>
                                    
                                    <TradeGrandTotal Month={formData.month} tomonth={formData.tomonth} generate={formData.generate} toyear={formData.toyear} year={formData.year} UserId={details.userId} />
                                    
                                   
                                    ) : null}
                                    {selectcenter === true ? <TradeTotalGT tomonth={formData.tomonth} toyear={formData.toyear} generate={formData.generate} Month={formData.month} year={formData.year} /> : null}
                            </tr>
                            
                            


                        </table>

                    </div>

                    </> : <h3>Please Select Month and Year to generate Report!!!</h3>}



                </Block>




            </Content>

        </React.Fragment>
    );
};

export default Trade;
